import { useState } from "react";
import { IoDownloadOutline } from "react-icons/io5";
import ReadOnAppModal from "components/v2/ReadOnAppModal";
import { BsExclamation } from "react-icons/bs";

const ReadOnAppBanner = ({ className = "" }) => {
	const [showModal, setShowModal] = useState(false);

	return (
		<>
			<div
				className={`bg-gradient-to-r from-green-50 to-emerald-50 border-2 border-akgreener rounded-lg p-4 shadow-sm ${className}`}
			>
				<div className="flex items-center gap-3">
					<div className="flex-shrink-0 bg-green-200 rounded-full">
						<BsExclamation size={50} className="text-akgreener" />
					</div>

					<div className="flex-1 min-w-0">
						<h4 className="text-lg font-semibold text-gray-900">
							Download the reader app to start reading
						</h4>
						{/* <p className="text-sm text-gray-600">
							Open or download your Akello Reader app to read your library books.
						</p> */}
					</div>

					<button
						type="button"
						onClick={() => setShowModal(true)}
						className="flex-shrink-0 inline-flex items-center gap-2 px-4 py-2 bg-akgreener text-white text-sm font-medium rounded-lg hover:bg-akgreen transition-colors"
					>
						<IoDownloadOutline size={16} />
						Get the App
					</button>
				</div>
			</div>

			<ReadOnAppModal
				visible={showModal}
				onClose={() => setShowModal(false)}
			/>
		</>
	);
};

export default ReadOnAppBanner;
